import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import React from "react"
import L10n from "../../../lib/carrot-l10n"
import { RRButtonFooter } from "../atoms/roundedrectangle/RRButtonFooter"
import { BodyLarge } from "../atoms/Bodies"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const WhatsImportantModule = () => (
  <RoundedRectangle backgroundColor="dark-blue">
    <BodyLarge color="white" font="publico-text">{l`whatsImportant`}</BodyLarge>
    <RRButtonFooter to="/providerfinder/whatsimportant">{l`learnMore`}</RRButtonFooter>
  </RoundedRectangle>
)
export { WhatsImportantModule }
